function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { PASSWORD_STRENGTH_TO_METER_CONVERSION } from './constants';
import ProgressIndicator from '../progressIndicator/ProgressIndicator';
import { getPasswordStrength, getPasswordStrengthLabelMarkup } from './utils';

var PasswordStrengthMeter =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(PasswordStrengthMeter, _React$PureComponent);

  function PasswordStrengthMeter() {
    _classCallCheck(this, PasswordStrengthMeter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PasswordStrengthMeter).apply(this, arguments));
  }

  _createClass(PasswordStrengthMeter, [{
    key: "render",

    /*
    A password strength meter (e.g. "weak", "strong") to provide feedback
    to the user as to the strength of input passwords on signup. Note that
    this component does not show on login.
    */
    value: function render() {
      var inputPassword = this.props.inputPassword;

      var _getPasswordStrength = getPasswordStrength(inputPassword),
          passwordScore = _getPasswordStrength.passwordScore,
          passwordStrengthLabel = _getPasswordStrength.passwordStrengthLabel,
          isPasswordValidLength = _getPasswordStrength.isPasswordValidLength;

      return React.createElement("div", {
        className: "eds-l-mar-top-4 eds-l-mar-bot-8",
        "data-automation": "password-strength-meter"
      }, React.createElement(ProgressIndicator, {
        type: "determinate",
        shape: "linear",
        style: "progress",
        progress: passwordScore * PASSWORD_STRENGTH_TO_METER_CONVERSION
      }), getPasswordStrengthLabelMarkup(passwordStrengthLabel, isPasswordValidLength));
    }
  }]);

  return PasswordStrengthMeter;
}(React.PureComponent);

_defineProperty(PasswordStrengthMeter, "propTypes", {
  /**
   *  The plaintext password to analyze
   */
  inputPassword: PropTypes.string.isRequired
});

export { PasswordStrengthMeter as default };